import React from "react";
import { PropTypes } from 'prop-types';
import TabsComponent from "../Tabs/Tabs";
import {
  ContentWrapper,
  ShowLessWrap,
  ImageWrap,
  ContinueWrap
} from "./styles";
import {
  PercentageWrapper,
  ErrMargin
} from "../../styles";
import { Row, Col } from "antd";
import { connect } from "react-redux";
import InputComponent from "../InputComponent";
import {
  setPercentage,
  setLegacyValues,
  handleError,
  showRemainingPercentage,
  jsonTemp,
  getAccordionStatus,
  updateAccordionState
} from "../../../actions";
import { PillButtonSelect } from "../LegacyAccordions/styles";
import upArrow from "../../../../../../assets/icons/short-arrow-t-green.svg";
import {
  PillButtonGreen,
  PillButtonGreenWrap
} from "../Tabs/styles";
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import ToJS from "../../../../../Contributions/Pages/ContributionsDashboard/HOC/toJS";
import { basicLegacy } from "../../../DefaultPropTypes";
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { AccordionContentDerivedStates } from "../../../selectors";

export const AccordionContent = props => {
  const handleSave = () => {
    try {
      initiateTracking('buttonStep','Open Additional Account', 'Step 2 Legacy options - '+ props.head,'Save to Continue');
      props.handleChange();
      let accordionState = Object.assign([],props.accordionStates); /** 0 - Not touched, 1 - Incomplete, 2 - Complete, 3 - Touched */
      accordionState[props.contentKey - 1] = 2;
      props.updateAccordionState(accordionState);
      props.showRemainingPercentage({
        showRemainingPercentage: true,
        key: props.contentKey,
        value: true
      });
    } catch (error) {
      recordError(error);
    }
  };

  const handleBlur = (e, type) => {
    let arr;
    if (props.isStep2Edit) {
      arr = props.tempData.tempJSON.legacyOptions;
    } else {
      arr = props.legacy.legacyOptions;
    }
    arr.filter(val => {
      if (val.optionId == props.contentKey) {
        if (val.percentage.length < 1) {
          return (val.percentageError = (
            <ErrMargin>Please enter percentage</ErrMargin>
          ));
        } else {
          return (val.percentageError = null);
        }
      }
    });
    if (props.isStep2Edit) {
      let tempData = props.tempData.tempJSON;
      tempData.legacyOptions = arr;
      props.jsonTemp({
        tempJSON: tempData,
        enableReset: true
      });
    } else {
      props.setPercentage({
        legacyOptions: {
          legacyOptions: arr
        }
      });
    }
  };
  const handleChange = (e, type, legacy) => {
    let reg = /^[0-9]{0,3}$/;
    let arr = legacy;
    if (reg.test(e.target.value)) {
      arr.filter(val => {
        if (val.optionId == props.contentKey) {
          if (e.target.value.length > 0) {
            val.percentageError = null;
          }
          if (e.target.value > 100) {
          } else {
            return (val.percentage = e.target.value);
          }
        }
      });
    }
    if (props.isStep2Edit) {
      let tempData = props.tempData.tempJSON;
      tempData.legacyOptions = arr;
      props.jsonTemp({
        tempJSON: tempData,
        enableReset: true
      });
    } else {
      props.setPercentage({
        legacyOptions: {
          legacyOptions: arr
        }
      });
    }
  };

  let data;
  if (props.isStep2Edit) {
    data = props.tempData.tempJSON.legacyOptions;
  } else {
    data = props.legacy.legacyOptions;
  }
  return (
    <ContentWrapper>
      <PercentageWrapper>
        <Row>
          <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
            <InputComponent
              data-test="inpcomp"
              handleBlur={e => handleBlur(e, "percentage")}
              id={`percentage${props.successorKey}${props.contentKey}`}
              title={
                props.contentKey == 1 ? 
                  "Total percentage for all successor advisors" : 
                    props.contentKey == 3 ? "Percentage to endow" : "Percentage"
              }
              hoverTitle="Percentages must be entered in whole numbers"
              placeholder="Enter percentage"
              handleInputChange={e => handleChange(e, "percentage", data)}
              value={
                data[props.contentKey - 1].percentage != 0
                  ? data[props.contentKey - 1].percentage
                  : null
              }
            />{" "}
            {data[props.contentKey - 1].percentageError
              ? data[props.contentKey - 1].percentageError
              : null}
          </Col>
        </Row>
      </PercentageWrapper>

      {props.contentKey == 1 ||
      props.contentKey == 2 ||
      props.contentKey == 4 ? (
        <TabsComponent
          handleChange={props.handleChange}
          contentKey={props.contentKey}
          head={props.head}
        />
      ) : props.contentKey == 3 || props.contentKey == 5 ? (
        <Row>
          {props.percentage ||
          (props.tempData &&
            props.tempData.tempJSON.legacyOptions[props.contentKey - 1]
              .percentage) ? (
            <ContinueWrap >
              <PillButtonGreenWrap>
                <PillButtonGreen data-test="save&continue" onClick={handleSave}>
                  Save to Continue
                </PillButtonGreen>
              </PillButtonGreenWrap>
            </ContinueWrap>
          ) : (
            <ShowLessWrap>
              <CapsuleButton 
                text = 'Show Less'
                onClick = {props.handleChange}
                whiteBackground = {true}
                iconType = "arrowUp"
              />
            </ShowLessWrap>
          )}
        </Row>
      ) : null}
    </ContentWrapper>
  );
};

const mapStateToProps = (state, ownProps) => ({
  legacy: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions"]),
  percentage: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions",
    "legacyOptions",
    `${ownProps.contentKey - 1}`,
    "percentage"
  ]),
  ...AccordionContentDerivedStates(state.toJS())
});

const mapDispatchToProps = dispatch => ({
  setPercentage: val => dispatch(setPercentage(val)),
  setLegacyValues: val => dispatch(setLegacyValues(val)),
  handleError: val => dispatch(handleError(val)),
  showRemainingPercentage: val => dispatch(showRemainingPercentage(val)),
  jsonTemp: val => dispatch(jsonTemp(val)),
  getAccordionStatus: val => dispatch(getAccordionStatus(val)),
  updateAccordionState: data => dispatch(updateAccordionState(data))
});

AccordionContent.propTypes = {
  accordionStates: PropTypes.any,
  contentKey: PropTypes.number,
  getAccordionStatus: PropTypes.func,
  handleChange: PropTypes.func,
  handleError: PropTypes.func,
  head: PropTypes.string,
  isStep2Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  legacy: PropTypes.shape({
    legacyOptions: basicLegacy,
  }),
  percentage: PropTypes.string,
  setLegacyValues: PropTypes.func,
  setPercentage: PropTypes.func,
  showRemainingPercentage: PropTypes.func,
  tempData: PropTypes.any,
  updateAccordionState: PropTypes.func,
}

export default ToJS(connect(
  mapStateToProps,
  mapDispatchToProps
)(AccordionContent));